import React from 'react'
import styled from 'styled-components'
import useReportServices from '../hooks/useReportServices'
import DatePickerRangeISO from '../../../knisotLines/Components/DatePickerRangeISO'
import SearchBlockWithTitle from '../../../procedures/Q8/Layouts/SearchBlockWithTitle'
import SearchReportGroup from './SearchReportGroup'
import ControlButton from '../../../../../../generic/buttons/ControlButton'
import SearchSeller from '../../../market/Collect/Components/SearchSeller'
import { ISellerItem } from '../../../../../../modules/API/Defaults/models/seller'
import SearchProblem from '../../Components/SearchProblem'
import { IProblemListItem } from '../../../../../../modules/API/TeudotProblems/models/problems'
import { IClientsItem } from '../../../../../../modules/API/Defaults/models/customers'
import { IProductListItemNode } from '../../../../../../modules/API/Defaults/models/productListNode'
import SearchCustomers from '../../../forcasts/Supply/Components/SearchCustomers'
import SearchProduct from '../../../forcasts/Products/Components/SearchProduct'

type Props = {
  date: Date[]
  setDate: React.Dispatch<React.SetStateAction<Date[]>>
  handleGetReports: () => void
  selectedSeller: number
  setSelectedSeller: React.Dispatch<React.SetStateAction<number>>
  selectedProblemType: number
  setSelectedProblemType: React.Dispatch<React.SetStateAction<number>>
  selectedCustomer: number
  setSelectedCustomer: React.Dispatch<React.SetStateAction<number>>
  selectedGroupBy: number
  setSelectedGroupBy: React.Dispatch<React.SetStateAction<number>>
  selectedProduct: number
  setSelectedProduct: React.Dispatch<React.SetStateAction<number>>
  isOpenFilterModal: boolean
  sellerList: ISellerItem[]
  problemTypeList: IProblemListItem[]
  customerList: IClientsItem[]
  productList: IProductListItemNode[]
  isAllowToFetchForReports: () => boolean
  handleModalFilter: () => void
}

const ReportFilterModal = ({
  date,
  setDate,
  handleGetReports,
  selectedSeller,
  setSelectedSeller,
  selectedProblemType,
  setSelectedProblemType,
  selectedCustomer,
  setSelectedCustomer,
  selectedGroupBy,
  setSelectedGroupBy,
  selectedProduct,
  setSelectedProduct,
  isOpenFilterModal,
  sellerList,
  problemTypeList,
  customerList,
  productList,
  handleModalFilter,
  isAllowToFetchForReports,
}: Props) => {
  console.log(problemTypeList)
  return (
    <ReportFilterModalWrapper>
      <SearchBlockWrapper>
        <DatePickerRangeISO
          selectedDates={date}
          onChange={setDate}
        />
        <SearchBlockWithTitle
          title='סיכום לפי'
        >
          <SearchReportGroup
            required={selectedGroupBy === 0}
            placeholder='חפש לפי'
            disabled={false}
            selectedGroupBy={selectedGroupBy}
            setSelectedGroupBy={setSelectedGroupBy}
          />
        </SearchBlockWithTitle>
        <SearchBlockWithTitle
          title='משווק'
        >
          <SearchSeller
            defaultID={selectedSeller}
            setSellerID={setSelectedSeller}
            list={sellerList}
          />
        </SearchBlockWithTitle>
        <SearchBlockWithTitle
          title='סוג פניה'
        >
          <SearchProblem
            list={problemTypeList}
            defaultID={selectedProblemType}
            setProblemType={setSelectedProblemType}
          />
        </SearchBlockWithTitle>
        <SearchBlockWithTitle
          title='לקוח'
        >
          <SearchCustomers
            list={customerList}
            defaultID={selectedCustomer}
            setCustomerID={setSelectedCustomer}
          />
        </SearchBlockWithTitle>
        <SearchBlockWithTitle
          title='פריט'
        >
          <SearchProduct
            list={productList}
            defaultProductID={selectedProduct}
            setDefaultProductID={setSelectedProduct}
          />
        </SearchBlockWithTitle>
      </SearchBlockWrapper>
      {
        
        <ControlButton
          lable='חפש'
          handleClick={handleGetReports}
          disabled={!isAllowToFetchForReports()}
        />

      }
    </ReportFilterModalWrapper>
  )
}
const ReportFilterModalWrapper = styled.div`
    width: 90%;
    height: 100%;
    display: flex;
    flex-flow: column;
    gap: 1em;
    background: #fff;
    align-items: center;
    overflow-y: hidden;
`
const SearchBlockWrapper = styled.div`
    width: 100%;
    height: 80%;
    display: flex;
    flex-flow: column;
    align-items: center;
    overflow-y: auto;
    gap: 1em;
    &::-webkit-scrollbar {
      width: 0;
    }
`
export default ReportFilterModal